import React, {useState, useEffect, useCallback} from 'react';
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import CardContent from '@mui/material/CardContent';
import CircularProgress from '@mui/material/CircularProgress';
import qs from 'qs';
import { withStyles } from '@mui/styles';

import './style.css';
import jwt_decode from "jwt-decode";
import liff from "@line/liff";

const ColorButton = withStyles((theme) => ({
    root: {
        color: '#FFFFFF',
        padding: '6px 16px',
        backgroundColor: '#00C300',
        '&:hover': {
            backgroundColor: '#00E000',
        },
        '&:active': {
            backgroundColor: '#00B300',
        },
    },
}))(Button);

const lineAuthentication = async() => {
    const redirectUri = `${process.env.REACT_APP_BASE_URL}/c/login`;
    liff.login({ redirectUri: redirectUri });
};

export default function CustomerLogin(props) {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const history = useHistory();

    const tokenProcess = useCallback((next) => {
        lineAuthentication().then(r=>{
            next();
        });
    }, []);

    useEffect(() => {
        const code = qs.parse(props.location.search, { ignoreQueryPrefix: true }).code;
        if(code){
            let codeVerifier = localStorage.getItem('code_verifier');
            let payload = {code: code, redirectUri: process.env.REACT_APP_BASE_URL+'/hm/login'};
            if(codeVerifier){
                payload.codeVerifier = codeVerifier;
            }
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            };
            const url = process.env.REACT_APP_API_BASE_URL + '/oauth/line/token';
            fetch(url, requestOptions)
                .then(results => results.json())
                .then(data => {
                    setLoading(false);
                    if(data.token){
                        localStorage.setItem('token', data.token);
                        let customer = {
                            displayName: data.displayName,
                            pictureUrl: data.pictureUrl
                        };
                        localStorage.setItem('customer', JSON.stringify(customer));
                        history.push('/c/orders');
                    } else {
                        localStorage.removeItem('token');
                        history.push('/hm/login');
                    }
                });
        } else {
            // get customer token by line
            let token = localStorage.getItem('token');
            if(!token){
                tokenProcess(function (){
                    setLoading(false);
                });
            } else {
                let decoded = jwt_decode(token);
                if (Date.now() >= decoded.exp * 1000){
                    console.log('expired');
                    tokenProcess(function (){
                        setLoading(false);
                    });
                } else {
                    console.log('not expired');
                    const liffId = process.env.REACT_APP_LINE_LIFF_ID;
                    liff.init({ liffId: liffId, withLoginOnExternalBrowser: false }).then(()=>{
                        setLoading(false);
                    }).catch(err=>{throw err});
                }
            }
        }
    }, [history, props, tokenProcess]);

    const handleClick = () => {
        history.push('/c/signin');
    };

    return (
        <div>
            {loading &&
            <Box display="flex" justifyContent="center" mt={4}>
                <CircularProgress size={20}/>
            </Box>
            }
            {!loading &&
                <>
                    <Container>
                        <Card style={{marginTop: '1rem'}}>
                            <CardContent>
                                <Box display="flex" justifyContent="center" pt={4}>
                                    <img alt="DUCK ORDER" src={`${process.env.REACT_APP_CDN_BASE_URL}/public/assets/foodkub.png`} width="200px" />
                                </Box>
                                <Box display="flex" justifyContent="center" pt={4}>
                                    <ColorButton
                                        variant="contained"
                                        disableElevation
                                        fullWidth={true}
                                        size="large"
                                        startIcon={<img width={"32px"} alt="LINE" src="data:image/png;base64,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" />}
                                        onClick={(e) => handleClick(e)}
                                    >
                                        {t('login.line')}
                                    </ColorButton>
                                </Box>
                            </CardContent>
                        </Card>
                    </Container>
                </>
            }
        </div>
    )
}